import { listRecognitionRecipientsSummary } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { filter, size } from 'lodash/fp'

export const MANAGER_SENT_RECOGNITION_QK = 'managerSentRecognitionSummaryQueryKey'

export const useManagerRecognitionSummary = () => {
  const { data, isLoading } = useQuery({
    queryKey: [MANAGER_SENT_RECOGNITION_QK],
    queryFn: () =>
      listRecognitionRecipientsSummary({
        ownReports: true,
        page: 1,
        pageSize: 100,
        embeds: ['members'],
      }),
    refetchOnMount: false,
  })

  const totalCount = data?.total
  const recognizedCount = size(filter(item => item?.receivedCount > 0, data?.results))
  const notRecognized = filter(item => item?.receivedCount === 0, data?.results)

  return {
    isLoading,
    totalCount,
    recognizedCount,
    notRecognized,
  }
}
